module.exports = __webpack_public_path__ + "static/img/ic_bottom_heart_off@2x.cdbfd06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_heart_off@2x.png
// module id = 4Yp4
// module chunks = 1